.chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-pill);
  background: var(--panel-2);
  color: var(--ink-2);
  font-weight: 600;
  white-space: nowrap;
}

/* One height, 20px (16px line, 1px padding, 1px border), in both sizes: the size changes the icon and
   the side padding, not the chip's height, so a row of mixed chips has one edge. */
.md {
  padding: 1px 10px 1px 8px;
  font-size: var(--t-min);
  line-height: 16px;
}

.sm {
  padding: 1px 8px 1px 6px;
  font-size: var(--t-min);
  line-height: 16px;
}

.icon {
  flex-shrink: 0;
}

/* A block of its own, because `::first-letter` does not apply to a flex item's anonymous text. */
.text {
  display: inline-block;
}

.text::first-letter {
  text-transform: uppercase;
}

.crit {
  border-color: var(--crit-line);
  background: var(--crit-w);
  color: var(--crit);
}

.warn {
  border-color: var(--warn-line);
  background: var(--warn-w);
  color: var(--warn);
}

.ok {
  border-color: var(--ok-line);
  background: var(--ok-w);
  color: var(--ok);
}

.info {
  border-color: var(--info-line);
  background: var(--info-w);
  color: var(--info);
}

.neutral {
  border-color: var(--line-2);
  background: var(--panel-2);
  color: var(--ink-2);
}
